var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBxsSchool(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.7151 9.50446H17.8934V4.03945H18.8042V2.21777H4.23085V4.03945H5.14169V9.50446H3.32002C3.07845 9.50446 2.84677 9.60042 2.67596 9.77124C2.50514 9.94205 2.40918 10.1737 2.40918 10.4153V18.6128H20.6259V10.4153C20.6259 10.1737 20.5299 9.94205 20.3591 9.77124C20.1883 9.60042 19.9566 9.50446 19.7151 9.50446ZM13.3392 16.7911V13.1478H9.69587V16.7911H6.96336V4.03945H16.0717V16.7911H13.3392Z",
    fill: "#FEC200"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.78467 5.86133H10.6063V7.683H8.78467V5.86133ZM12.428 5.86133H14.2497V7.683H12.428V5.86133ZM8.78467 9.50467H10.6063V11.3263H8.78467V9.50467ZM12.428 9.50467H14.2497V11.3263H12.428V9.50467Z",
    fill: "#FEC200"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBxsSchool);
export default __webpack_public_path__ + "static/media/bxs_school.255152e0b3e3f48c2cc11e6ae8235b28.svg";
export { ForwardRef as ReactComponent };